<template>
  <div class="shipping-preference">
    <el-button
      type="primary"
      :disabled="!waybillNo"
      @click="handleOpen"
    >{{ $lang("收货偏好") }}</el-button>
    <el-dialog
      title="收货偏好设置"
      :append-to-body="true"
      :visible="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="preference-content" v-loading="loading">
        <!-- 一级选择 -->
        <div class="first-level">
          <div class="level-title">{{ $lang("配送方式") }}</div>
          <el-radio-group
            v-model="formData.deliveryMethod"
            @change="handleFirstLevelChange"
          >
            <el-radio-button
              v-for="item in firstDeliveryDic"
              :key="item.labelCode"
              :label="item.labelCode"
            >
              {{ item.labelName }}
            </el-radio-button>
          </el-radio-group>
          <!-- 二级 -->
          <div style="margin-top: 10px;">
            <el-radio-group
              v-show="secondLevelOptions.length"
              v-model="formData.deliverySubOption"
              size="mini"
            >
              <el-radio-button
                v-for="item in secondLevelOptions"
                :key="item.labelCode"
                :label="item.labelCode"
              >
                {{ item.labelName }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>

        <div class="second-level">
          <div class="level-title">{{ $lang("沟通方式") }}</div>
          <el-radio-group v-model="formData.communicationMethod">
            <el-radio-button
              v-for="item in communicationTypeDic"
              :key="item.labelCode"
              :label="item.labelCode"
            >
              {{ item.labelName }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div style="margin-top: 20px;text-align: right;">
        <el-button type="info" @click="handleReset">{{ $lang("重置") }}</el-button>
        <el-button type="info" @click="handleClose">{{ $lang("取消") }}</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">{{ $lang("提交") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { WaybillTagContentApi } from './pool'

export default {
  props: {
    waybillNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      firstDeliveryDic: [],
      formData: {
        deliveryMethod: '', // 一级选择
        deliverySubOption: '', // 二级选择
        communicationMethod: '' // 沟通方式
      },
      communicationTypeDic: []
    }
  },
  computed: {
    // 根据一级选择获取二级选项
    secondLevelOptions() {
      const selected = this.firstDeliveryDic.find(item => item.labelCode === this.formData.deliveryMethod)
      return selected ? selected.childLabelList
        : []
    }
  },
  methods: {
    // 获取收货偏好枚举
    async getShippingPreference() {
      const { code, msg, data } = await WaybillTagContentApi.reqAllWaybillTag()
      if (code === 1) {
        this.firstDeliveryDic = (data || []).filter(item => item.labelCategory === 'CS_DELIVERY_METHOD')
        this.communicationTypeDic = (data || []).filter(item => item.labelCategory === 'CS_COMMUNICATION_METHOD')
      } else {
        this.$message.error(msg)
      }
    },
    handleReset() {
      this.formData = {
        deliveryMethod: '', // 一级选择器
        deliverySubOption: '', // 二级选择器
        communicationMethod: '' // 沟通方式
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.formData = {
        deliveryMethod: '', // 一级选择
        deliverySubOption: '', // 二级选择
        communicationMethod: '' // 沟通方式
      }
    },
    handleFirstLevelChange(value) {
      const item = this.firstDeliveryDic.find(item => item.labelCode === value)
      this.formData.deliverySubOption = ''
      // 指定地点 二级必填
      if (item.labelCode === 'kfpsfs_zddd') {
        this.formData.deliverySubOption = item.childLabelList[0].labelCode
      }
    },
    // 查询设置的偏好
    async reqReceiveLabelsCode() {
      const { code, msg, data } = await WaybillTagContentApi.reqReceiveLabelsCode({ waybillNo: this.waybillNo })
      if (code === 1) {
        this.formData = data || {}
      } else {
        this.$message.error(msg)
      }
    },
    async submitForm() {
      // 验证表单数据
      if (!this.formData.deliveryMethod && !this.formData.communicationMethod) {
        this.$message.warning('请选择派送方式或者沟通方式')
        return
      }
      this.loading = true
      const { code, msg } = await WaybillTagContentApi.reqUpdateWaybillTag({ waybillNo: this.waybillNo, ...this.formData }).catch(() => {
        this.loading = false
      })
      this.loading = false
      if (code === 1) {
        // 提交表单数据
        this.$message.success(msg)
        this.handleClose()
      } else {
        this.$message.error(msg)
      }
    },
    handleOpen() {
      this.getShippingPreference()
      // this.reqReceiveLabelsCode()
      this.dialogVisible = true;
    }
  }
}
</script>
<style lang="scss" scoped>
.shipping-preference {
  display: inline-block;
  margin-right: 10px;
}

.preference-content {
  .level-title {
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
  }

  .first-level {
    margin-bottom: 20px;
  }

  .second-level {
    padding-top: 10px;
    border-top: 1px solid #eee;
  }
}
</style>
